import { Button, Grid, IconButton, Stack, styled } from '@mui/material';
import Typography from '@mui/material/Typography';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import React, { Fragment, useMemo } from 'react';
import { ClientOption, CreateFiles, useInjection } from './hook';
import { AddNote, LeadBoxMemo } from 'app/pages/FileDetail/components/LeadBox';
import { Lead, TFile } from 'types/user';
import { ModalNewLead, NewLeadForm } from 'app/components/modules/ModalNewLead';
import { useLoading } from 'contexts/loading';
import { FormProvider } from 'react-hook-form';
import { TypeOption } from 'app/pages/Admin/NewFileSetUpPage/hook';
import { includes } from 'lodash';
import { IconCollapsible } from 'assets/icons/IconCollapsible';
import { InfoDetailFile } from '../InfoDetailFile';
import { FileSummaryMemo } from './components/FileSummary';
import { ReminderForm } from './components/ReminderForm';
import { PricingForm } from './components/PricingForm';
import { DocumentFile } from './components/DocumentFile';
import { PhotoFile } from './components/PhotoFile';
import { SummaryLog } from '../../../../FileDetail/components/SummaryLog';
import { ModalReport } from '../../../../FileDetail/components/ModalReport';
import { StorageServices } from 'services/storage';
import { ListBoxMemo } from '../../../../FileDetail/components/ListInbox';
export type FileFormProps = {
  createForm: ({
    value,
    fileDocument,
    filePhotos
  }: {
    value: CreateFiles;
    filePhotos?: { file: File; url: string }[];
    fileDocument?: { file: File; url: string }[];
  }) => void;
  isEdit?: boolean;
  id?: number;
  leads?: Lead[];
  handleAddNewLead?: (value: NewLeadForm) => void;
  handleDeleteNoteLead?: (idNote: number, idLead: number) => void;
  handleAddTowYards?: ({
    idLead,
    towYards
  }: {
    idLead: number;
    towYards: { value: string; checked: boolean; user?: { role: string } }[];
  }) => void;
  handleAddNewNote?: ({ isNewLead, idLead, textNote, isAdmin }: AddNote) => void;
  handleEditNote?: (
    idLead: number,
    idNote: number,
    content: string,
    notePhotosIds: number[]
  ) => void;
  loadingModalNewLead?: boolean;
  initFile?: TFile;
  handleDeleteLead?: (id: number) => void;
  handleDeleteFile?: () => void;
  handleDeleteTowYards?: ({ idTowYards, idLead }: { idLead: number; idTowYards: number }) => void;
  handleChangeVinStatus?: ({ vinStatus, idLead }: { idLead: number; vinStatus: string }) => void;
  handleUploadFileCarfax?: ({
    files,
    idLead,
    oldDocIds
  }: {
    idLead: number;
    files: File[];
    oldDocIds: number[];
  }) => void;
  handleDeleteDocumentLead?: ({
    idLead,
    oldDocIds
  }: {
    idLead: number;
    oldDocIds: number[];
  }) => void;
  optionClient?: ClientOption[];
  optionClientChild?: ClientOption[];
  optionAuctionDeliveryLocation?: TypeOption[];
  changeOptionClient?: (value: number) => void;
  handleCloseNotFound?: () => void;
  handleCloseClient?: () => void;
  handleOnHoldFile?: () => void;
  reloadPage?: () => Promise<void>;
  handleChooseRuleOut?: (idLead: number, ruleOut: boolean) => void;
  handleRemindLead?: (idLead: number, remind: boolean) => void;
};
const storage = new StorageServices();

export const FileForm = ({
  createForm,
  isEdit,
  id,
  leads,
  handleAddNewLead,
  handleEditNote,
  handleAddNewNote,
  handleDeleteNoteLead,
  handleDeleteLead,
  initFile,
  handleDeleteFile,
  handleAddTowYards,
  handleDeleteTowYards,
  handleChangeVinStatus,
  handleUploadFileCarfax,
  handleDeleteDocumentLead,
  optionClient,
  optionClientChild,
  optionAuctionDeliveryLocation,
  changeOptionClient,
  handleCloseNotFound,
  handleOnHoldFile,
  reloadPage,
  handleChooseRuleOut,
  handleRemindLead,
  handleCloseClient
}: FileFormProps) => {
  const role = storage.getRole();
  const { loading } = useLoading();
  const {
    onSubmitForm,
    isAdmin,
    isCompleted,
    idsLeadOpen,
    optionsUser,
    setIdsLeadOpen,
    modalNewLead,
    setModalNewLead,
    openForm,
    setOpenForm,
    methods,
    sortedLeads,
    showModalReport,
    asyncHandleCreateReport,
    handleUpdateBailiff,
    onClickSeized,
    handleAddNotePhotos,
    handleChooseEarlyMorning,
    handleChooseDoorKnock,
    handleChooseNotRegister,
    asyncHandleRequestMvs,
    setShowModalReport
  } = useInjection({ createForm, id, isEdit, initFile, leads, reloadPage });
  const isUser = useMemo(() => role === 'USER', [role]);
  return (
    <Stack gap={2} pb={10}>
      <FormProvider {...methods}>
        <Stack flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Typography fontSize={24} fontWeight={700} color={'#22374A'}>
            {isEdit ? 'Edit Files' : 'New File'}
          </Typography>
          <Stack
            flex={1}
            flexDirection={'row'}
            justifyContent={'flex-end'}
            flexWrap={'wrap'}
            gap={2.5}>
            {isEdit && !isUser && (
              <Button
                onClick={handleDeleteFile}
                style={{
                  width: '170px',
                  borderRadius: '10px',
                  border: '2px solid #DA0000',
                  color: '#DA0000',
                  fontWeight: '600',
                  fontSize: '16px',
                  height: '56px',
                  gap: '8px'
                }}>
                <img src={'/icons/icon_delete.svg'} alt={'icon_delete'} width={'24px'} />
                Delete File
              </Button>
            )}
            {!isUser && isEdit && (
              <>
                {[
                  {
                    label: 'Close Not Found',
                    onClick: handleCloseNotFound,
                    styles: {
                      background: '#888',
                      ':hover': {
                        background: '#888'
                      }
                    }
                  },
                  {
                    label: 'Close Client Request',
                    onClick: handleCloseClient,
                    styles: {
                      background: '#888',
                      ':hover': {
                        background: '#888'
                      }
                    }
                  },
                  {
                    label: initFile?.onHold ? 'Active' : 'On Hold',
                    onClick: handleOnHoldFile,
                    styles: {
                      background: '#888',
                      ':hover': {
                        background: '#888'
                      }
                    }
                  }
                ].map((btn, idx) => (
                  <ButtonCustom
                    key={btn.label + idx}
                    style={{ width: '200px', height: '56px', ...btn.styles }}
                    onClick={btn.onClick}
                    loading={loading}
                    label={btn.label}
                  />
                ))}
              </>
            )}
            {!isCompleted && (
              <ButtonCustom
                style={{ width: '200px' }}
                onClick={methods.handleSubmit(onSubmitForm)}
                loading={loading}
                label={isEdit ? 'Save' : 'Create File'}
              />
            )}
            {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              isEdit && (initFile?.fileStatusTransition as any)?.status === 'OPENED' && (
                <Stack
                  flexDirection={'row'}
                  alignItems={'flex-start'}
                  justifyContent={'flex-end'}
                  gap={2.5}
                  width={'100%'}>
                  <ButtonCustom
                    sx={{ width: { md: '200px', xs: '100%' } }}
                    label={'Redemption'}
                    isCancel
                    onClick={handleUpdateBailiff}
                    fullWidth
                  />
                  <ButtonCustom
                    sx={{
                      width: {
                        md: '200px',
                        xs: '100%',
                        background: '#888',
                        ':hover': {
                          background: '#888'
                        }
                      }
                    }}
                    label={'Condition Report'}
                    onClick={() => setShowModalReport(true)}
                    fullWidth
                  />
                  {initFile?.id && (
                    <ModalReport
                      fileId={Number(initFile.id)}
                      onSubmitSuccess={asyncHandleCreateReport}
                      isOpen={showModalReport}
                      onClose={() => setShowModalReport(false)}
                    />
                  )}
                  <ButtonCustom
                    sx={{ width: { md: '200px', xs: '100%' } }}
                    label={'SEIZED'}
                    onClick={onClickSeized}
                    fullWidth
                  />
                </Stack>
              )
            }
          </Stack>
        </Stack>
        {isEdit && (
          <Stack zIndex={99} width={'max-content'}>
            <IconButton onClick={() => setOpenForm(!openForm)}>
              <IconCollapsible open={openForm} />
            </IconButton>
          </Stack>
        )}
        <WrapperBox
          gap={2.5}
          width={!isEdit ? '100%' : openForm ? '160%' : '100%'}
          flexDirection={'row'}>
          <Grid
            spacing={2.5}
            container
            sx={{
              flexWrap: 'nowrap'
            }}>
            {(openForm || !isEdit) && (
              <Grid item container sm={isEdit ? 8 : 12}>
                <Wrapper
                  style={{ border: '1px solid #EEEEEE', borderRadius: '20px' }}
                  maxWidth={isEdit ? 'unset' : 'unset'}>
                  <InfoDetailFile
                    isUser={isUser}
                    createdAt={initFile?.createdAt}
                    isCompleted={isCompleted || isUser}
                    optionsUser={optionsUser}
                    changeOptionClient={changeOptionClient}
                    optionAuctionDeliveryLocation={optionAuctionDeliveryLocation}
                    optionClientChild={optionClientChild}
                    optionClient={optionClient}
                  />
                </Wrapper>
              </Grid>
            )}
            {isEdit && (
              <Grid item container md={12}>
                <Stack
                  style={{
                    border: '1px solid #EEEEEE',
                    borderRadius: '20px',
                    width: '100%'
                  }}>
                  <Grid item container md={12}>
                    <Grid item md={4}>
                      <Stack
                        px={2.5}
                        gap={'25px'}
                        py={'35px'}
                        height={'100%'}
                        style={{ borderRight: '1px solid #EEEEEE' }}>
                        <Typography fontWeight={700} fontSize={18} lineHeight={'30px'}>
                          Quick Summary
                        </Typography>
                        <FileSummaryMemo reloadPage={reloadPage} file={initFile} />
                      </Stack>
                    </Grid>
                    <Grid item md={4}>
                      {isEdit && (
                        <Wrapper
                          alignItems={'center'}
                          height={'100%'}
                          style={{ borderRight: '1px solid #EEEEEE' }}>
                          <ListLead>
                            <Typography
                              style={{ fontSize: '24px', fontWeight: '600', color: '#000' }}>
                              Leads
                            </Typography>
                            {sortedLeads?.map((item, index) => (
                              <Fragment key={index}>
                                <LeadBoxMemo
                                  onOpenLead={() => {
                                    const hasId = includes(idsLeadOpen, Number(item.id));
                                    if (hasId) {
                                      setIdsLeadOpen((prevState) =>
                                        prevState.filter((pre) => pre !== Number(item.id))
                                      );
                                      return;
                                    }
                                    setIdsLeadOpen((prevState) => [...prevState, Number(item.id)]);
                                  }}
                                  handleAddNewPhotos={(files, textNote, isEarly) =>
                                    handleAddNotePhotos({ id: item?.id, files, textNote, isEarly })
                                  }
                                  isOpen={includes(idsLeadOpen, Number(item.id))}
                                  isCompleted={isCompleted}
                                  isAdmin={isAdmin}
                                  key={index}
                                  item={item}
                                  handleChooseEarlyMorning={handleChooseEarlyMorning}
                                  handleChooseDoorKnock={handleChooseDoorKnock}
                                  handleDeleteNoteLead={handleDeleteNoteLead}
                                  handleAddNewNote={handleAddNewNote}
                                  handleEditNote={handleEditNote}
                                  handleDeleteLead={() => {
                                    if (item.id) {
                                      handleDeleteLead && handleDeleteLead(item.id);
                                    }
                                  }}
                                  handleAddTowYards={handleAddTowYards}
                                  handleChooseNotRegister={handleChooseNotRegister}
                                  handleChooseRuleOut={handleChooseRuleOut}
                                  handleRemindLead={handleRemindLead}
                                  handleDeleteTowYards={handleDeleteTowYards}
                                  handleChangeVinStatus={handleChangeVinStatus}
                                  handleUploadFileCarfax={handleUploadFileCarfax}
                                  handleDeleteDocumentLead={handleDeleteDocumentLead}
                                />
                              </Fragment>
                            ))}
                            <Stack>
                              {!isCompleted && (
                                <WrapperButton pb={isAdmin ? '10px' : '25px'}>
                                  <ButtonCustom
                                    onClick={() => {
                                      setModalNewLead(true);
                                    }}
                                    label={'New Lead'}
                                  />
                                </WrapperButton>
                              )}
                              <WrapperButton>
                                <ButtonCustom
                                  sx={{
                                    ...(initFile?.MVSRequested
                                      ? { background: '#888', ':hover': { background: '#666' } }
                                      : {})
                                  }}
                                  onClick={() => {
                                    const isCancelling = initFile?.MVSRequested;
                                    const message = isCancelling
                                      ? 'Are you sure you want to cancel the MVS request?'
                                      : 'Are you sure you want to request MVS?';
                                    if (!window.confirm(message)) return;
                                    asyncHandleRequestMvs(initFile?.id, !isCancelling);
                                  }}
                                  label={
                                    initFile?.MVSRequested ? 'Cancel MVS Request' : 'Request MVS'
                                  }
                                />
                              </WrapperButton>
                            </Stack>
                          </ListLead>
                          {!isCompleted && handleAddNewLead && (
                            <ModalNewLead
                              isAdmin={isAdmin}
                              isOpen={modalNewLead}
                              onClose={() => setModalNewLead(false)}
                              onSubmit={(value: NewLeadForm) => {
                                handleAddNewLead(value);
                                setModalNewLead(false);
                              }}
                              textTitle={'Add New Lead'}
                            />
                          )}
                        </Wrapper>
                      )}
                    </Grid>
                    <Grid item md={4}>
                      <Stack
                        px={2.5}
                        gap={'12px'}
                        pt={'35px'}
                        height={'100%'}
                        style={{ borderRight: '1px solid #EEEEEE' }}>
                        <Typography fontWeight={700} fontSize={18} lineHeight={'30px'}>
                          Notes
                        </Typography>
                        <Stack width={'100%'} flex={1}>
                          <SummaryLog
                            fileNotes={initFile?.fileNotes || []}
                            noTitle
                            leads={initFile?.leads || []}
                          />
                        </Stack>
                        <ListBoxMemo
                          titleStyled={{ style: { fontWeight: '600', color: '#22374a' } }}
                          fileId={Number(initFile?.id)}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Grid>
            )}
          </Grid>
        </WrapperBox>
        {initFile && reloadPage && (
          <>
            <Stack
              style={{ marginTop: '40px' }}
              gap={'40px'}
              flexDirection={'column'}
              maxWidth={'1200px'}>
              <Grid container md={12} spacing={3}>
                <Grid item md={6}>
                  <ReminderForm file={initFile} reloadFile={reloadPage} />
                </Grid>
                {!isUser && (
                  <Grid item md={6}>
                    <PricingForm file={initFile} reloadPage={reloadPage} />
                  </Grid>
                )}
              </Grid>
              <Grid container md={12} spacing={3}>
                <Grid item md={6}>
                  <DocumentFile isUser={isUser} file={initFile} reloadPage={reloadPage} />
                </Grid>
                <Grid item md={6}>
                  <PhotoFile isUser={isUser} file={initFile} reloadPage={reloadPage} />
                </Grid>
              </Grid>
            </Stack>
          </>
        )}
      </FormProvider>
    </Stack>
  );
};
const WrapperBox = styled(Stack)(() => ({
  '.animated-container': {
    transition: 'transform 0.3s ease, opacity 0.3s ease, width 0.3s ease',
    transform: 'translateX(-100% - 30px)',
    opacity: 0,
    width: 0,
    overflow: 'hidden'
  },
  '.animated-container.open': {
    transform: 'translateX(0)',
    opacity: 1,
    width: '100%'
  },
  '.animated-container.close': {
    height: 0
  }
}));
const Wrapper = styled(Stack)(() => ({
  padding: '10px 20px',
  alignItems: 'center',
  gap: 20
}));

const ListLead = styled(Stack)(() => ({
  width: '100%',
  gap: 10,
  paddingTop: '20px'
}));
const WrapperButton = styled(Stack)(() => ({
  margin: '0 10px'
}));
